import TextField from "@/components/layouts/History/TextField";
import { getCurrencySymbol } from "@/pages/deals/helpers";

interface Props {
  currencyName: string;
}

const Currency: React.FC<Props> = ({ currencyName }) => {
  const currencySymbol = getCurrencySymbol(currencyName as string);
  return <TextField>{`${currencySymbol} ${currencyName}`}</TextField>;
};

export default Currency;
